var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('button',{staticClass:"back-button",on:{"click":_vm.goBack}},[_c('i',{staticClass:"mdi mdi-chevron-left back-icon"}),_c('span',{staticClass:"back-text"},[_vm._v("Atrás")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }